import { useAuthorizedValue } from "@packsize/authentication";
import { SecondaryNavbar, SiteContent } from "@packsize/components";
import { Outlet } from "react-router-dom";
import { useIntl } from "react-intl";
import type { FC } from "react";

import { JobQueueProvider } from "@/views/production/orders/job-queue-provider";
import { LocationControl } from "@/views/production/components/location-control";
import type { NavbarItem } from "@/components/navbar/types";

import RequireCurrentMachineGroup from "./require-current-machine-group";

export const ProductionRoutes: FC = () => {
	const intl = useIntl();

	const tabs: NavbarItem[] = [
		{
			link: "orders",
			text: intl.formatMessage({ id: "Orders", defaultMessage: "Orders" }),
		},
		useAuthorizedValue(
			{
				link: "packaging-creation",
				text: intl.formatMessage({ id: "Packaging Creation", defaultMessage: "Packaging Creation" }),
				selectableWithPg: true,
			},
			[
				"ManagePackagingSolutions",
				"ModifyAndSendPackagingSolutionToQueue",
				"SendPackagingSolutionToQueue",
				"CreatePackagingSolution",
			],
		),
		useAuthorizedValue(
			{
				link: "change-corrugate",
				text: intl.formatMessage({ id: "Change Corrugate", defaultMessage: "Change z-Fold" }),
			},
			"ChangeLoadedCorrugatesOnMachine",
		),
		useAuthorizedValue(
			{
				link: "machine-control",
				text: intl.formatMessage({ id: "Machine Control", defaultMessage: "Machine Control" }),
			},
			"AccessMachineControl",
		),
	].filter((tab): tab is NavbarItem => tab !== null);

	return (
		<SiteContent header={<SecondaryNavbar navbarItems={tabs} actions={<LocationControl />} />}>
			<RequireCurrentMachineGroup tabs={tabs}>
				<JobQueueProvider>
					<Outlet />
				</JobQueueProvider>
			</RequireCurrentMachineGroup>
		</SiteContent>
	);
};

export default ProductionRoutes;
